import { GET_ALL_ROLES } from "../../common/constants/ActionTypes";

const initialState = {
  errorMessage: "",
  showLoader: false,
  roleData: [],
};

export default function dashboardReducers(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_ROLES:
      return {
        ...state,
        roleData: action.payload,
      };
    default:
      return state;
  }
}
